import { useQuery } from '@apollo/client'
import { BORDER, TEXT_LABEL_STYLE } from '@User/MyAccountPage/styleConstants'
import pageStyles from '@User/MyAccountPage/styles.css'
import {
    ID_ENTERPRISE,
    ID_RESELLER,
} from '@Admin/AdminUserProfilePage/constants'
import { adminRolesQuery as userRolesQuery } from '@Admin/AdminUserProfilePage/query'
import { adminRolesQuery_me_roles as UserRole } from '@Admin/AdminUserProfilePage/__generated__/adminRolesQuery'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { IdentityType } from '~/redux-modules/identity/type'
import { useGetAllBusinessAccountFeaturesQuery } from '~/gql/graphql'

import { FinancePermissionsSubSection } from './FinancePermissionsSubSection'

interface FinancePermissionsSectionPropsType {
    identity: IdentityType
    shouldShow2FA: boolean
    businessAccountName?: string
}

export const FinancePermissionsSection = (
    props: FinancePermissionsSectionPropsType,
) => {
    const { shouldShow2FA, businessAccountName, identity } = props
    const businessAccountId =
        identity?.businessAccountMembership?.businessAccount?.id
    const { data: userRoles } = useQuery(userRolesQuery)

    const roles: UserRole[] = userRoles?.me?.roles || []

    const { data: getAllBusinessAccountFeatures } =
        useGetAllBusinessAccountFeaturesQuery({
            variables: {
                businessAccountId: businessAccountId,
            },
            fetchPolicy: 'network-only',
            skip: !businessAccountId,
        })

    const isPoEnabled = roles.some(role => role.name === ID_ENTERPRISE)
    const isResellerEnabled = roles.some(role => role.name === ID_RESELLER)

    return (
        <Box
            padding="24px 0"
            marginBottom={!shouldShow2FA && '16px'}
            borderBottom={shouldShow2FA && BORDER}
            className={pageStyles.mobileColBox}
        >
            <Box className={pageStyles.mobileLabel} direction="col">
                <Text style={TEXT_LABEL_STYLE}>FINANCIAL</Text>
                <Text style={TEXT_LABEL_STYLE}>PERMISSIONS</Text>
            </Box>
            <Box direction="col" width="100%">
                <FinancePermissionsSubSection
                    financeRole={ID_ENTERPRISE}
                    roleEnabled={isPoEnabled}
                    businessAccountName={businessAccountName}
                    businessAccountFeatures={
                        getAllBusinessAccountFeatures?.getAllBusinessAccountFeatures ||
                        []
                    }
                />
                <Box style={{ marginTop: '16px' }} />
                <FinancePermissionsSubSection
                    financeRole={ID_RESELLER}
                    roleEnabled={isResellerEnabled}
                    businessAccountName={businessAccountName}
                    businessAccountFeatures={
                        getAllBusinessAccountFeatures?.getAllBusinessAccountFeatures ||
                        []
                    }
                />
            </Box>
        </Box>
    )
}
